import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface NCFileDetailsNCFileTimelineProps {}

const NCFileDetailsNCFileTimelineComponent: FC<NCFileDetailsNCFileTimelineProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileTimeline = connect(null, {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFileTimelineComponent);

export { NCFileDetailsNCFileTimeline };
